import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { CardComponent } from '../../components/card/card.component';

@Component({
  selector: 'vectronic-viewer-json',
  templateUrl: './viewer-json.component.html',
  styleUrls: ['./viewer-json.component.scss'],
  imports: [CardComponent, NgxJsonViewerModule],
})
export class ViewerJsonComponent {
  data: { json: string } = inject(MAT_DIALOG_DATA);
  dialogRef = inject(MatDialogRef<ViewerJsonComponent>);

  get json() {
    if (typeof this.data?.json === 'string') return JSON.parse(this.data.json);
    else return this.data.json;
  }
}
